module.exports = __webpack_public_path__ + "static/img/device-s3.3d6bf067.png";